import { resourceActionTypes } from '../actions/types';
import _ from 'lodash';

const initialState = {
  images: [],
  imageSkip: null,
  imageLimit: 16,
  hasMoreImage: true,
  elements: [],
  elementSkip: null,
  elementLimit: 16,
  hasMoreElement: true,
  statistic: null,
  latestStatistic: null,
  texts: [],
  textSkip: null,
  textLimit: 16,
  hasMoreText: true,
  videos: [],
  videoSkip: null,
  videoLimit: 16,
  hasMoreVideo: true,
  backgrounds: [],
  backgroundSkip: null,
  backgroundLimit: 16,
  hasMoreBackground: true,
  userImages: [],
  userImageSkip: null,
  userImageLimit: 16,
  hasMoreUserImage: true,
  userVideos: [],
  userVideoSkip: null,
  userVideoLimit: 16,
  hasMoreUserVideo: true,
  userFolders: [],
  fonts: [],
  fontSkip: null,
  fontLimit: 16,
  hasMoreFont: true,
  uploading: false,
  loading: false,
  imageTags: [],
  folderState: null,
};

export function resource(state = initialState, action) {
  switch (action.type) {
    case resourceActionTypes.RESET_STATE:
      return {
        ...initialState,
      };
    case resourceActionTypes.UPLOAD_REQUEST:
      return {
        ...state,
        uploadProgress: action.progress,
        uploading: true,
      };
    case resourceActionTypes.UPLOAD_SUCCESS: {
      if (action.resource.type === 'Image') {
        return {
          ...state,
          uploading: false,
          userImages: [action.resource, ...state.userImages],
        };
      } else if (action.resource.type === 'Video') {
        return {
          ...state,
          uploading: false,
          userVideos: [action.resource, ...state.userVideos],
        };
      }
      break;
    }
    case resourceActionTypes.UPLOAD_FAILURE:
      return {
        ...state,
        error: action.error,
        uploading: false,
      };
    case resourceActionTypes.SEARCH_REQUEST:
      return {
        ...state,
        error: null,
        [`${action.resourceType.toLowerCase()}Status`]: 'loading',
        [`${action.resourceType.toLowerCase()}s`]: action.clear ? [] : state[`${action.resourceType.toLowerCase()}s`],
      };
    case resourceActionTypes.SEARCH_SUCCESS:
      switch (action.resourceType) {
        case 'Image':
          return {
            ...state,
            images: action.clear ? action.resources : [...state.images, ...action.resources],
            imageSkip: action.skip,
            imageLimit: action.limit,
            hasMoreImage: action.clear ? true : action.resources.length !== 0,
            imageStatus: 'success',
          };
        case 'Element':
          return {
            ...state,
            elements: action.clear ? action.resources : [...state.elements, ...action.resources],
            elementSkip: action.skip,
            elementLimit: action.limit,
            hasMoreElement: action.clear ? true : action.resources.length !== 0,
            elementStatus: 'success',
          };
        case 'Text':
          return {
            ...state,
            texts: action.clear ? action.resources : [...state.texts, ...action.resources],
            textSkip: action.skip,
            textLimit: action.limit,
            hasMoreText: action.clear ? true : action.resources.length !== 0,
            textStatus: 'success',
          };
        case 'Video':
          return {
            ...state,
            videos: action.clear ? action.resources : [...state.videos, ...action.resources],
            videoSkip: action.skip,
            videoLimit: action.limit,
            hasMoreVideo: action.clear ? true : action.resources.length !== 0,
            videoStatus: 'success',
          };
        case 'Background':
          return {
            ...state,
            backgrounds: action.clear ? action.resources : [...state.backgrounds, ...action.resources],
            backgroundSkip: action.skip,
            backgroundLimit: action.limit,
            hasMoreBackground: action.clear ? true : action.resources.length !== 0,
            backgroundStatus: 'success',
          };
        case 'Font':
          return {
            ...state,
            fonts: action.clear ? action.resources : [...state.fonts, ...action.resources],
            fontSkip: action.skip,
            fontLimit: action.limit,
            hasMoreFont: action.clear ? true : action.resources.length !== 0,
            fontStatus: 'success',
          };
        default:
          return {
            ...state,
          };
      }
    case resourceActionTypes.SEARCH_FAILURE:
      return {
        ...state,
        error: action.error,
        [`${action.resourceType.toLowerCase()}Status`]: 'failure',
      };
    case resourceActionTypes.USER_RESOURCE_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case resourceActionTypes.USER_RESOURCE_SUCCESS:
      switch (action.resourceType) {
        case 'Image':
          return {
            ...state,
            userImages: [...state.userImages, ...action.resources],
            userImageSkip: action.skip,
            userImageLimit: action.limit,
            hasMoreUserImage: action.resources.length !== 0,
            loading: false,
          };
        case 'Video':
          return {
            ...state,
            userVideos: [...state.userVideos, ...action.resources],
            userVideoSkip: action.skip,
            userVideoLimit: action.limit,
            hasMoreUserVideo: action.resources.length !== 0,
            loading: false,
          };
        default:
          return {
            ...state,
            loading: false,
          };
      }
    case resourceActionTypes.USER_RESOURCE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case resourceActionTypes.DELETE_REQUEST:
      return {
        ...state,
        error: null,
      };
    case resourceActionTypes.DELETE_SUCCESS:
      switch (action.resourceType) {
        case 'UserImage':
          return {
            ...state,
            userImages: action.resources,
          };
        default:
          return {
            ...state,
          };
      }
    case resourceActionTypes.DELETE_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case resourceActionTypes.USER_FOLDERS_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case resourceActionTypes.USER_FOLDERS_SUCCESS:
      return {
        ...state,
        userFolders: action.folders ? action.folders : [],
        loading: false,
      };
    case resourceActionTypes.USER_FOLDERS_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case resourceActionTypes.USER_ACTION_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case resourceActionTypes.USER_ACTION_SUCCESS:
      return {
        ...state,
        loading: false,
        [`${action.resourceType.toLowerCase()}s`]: action.resources,
      };
    case resourceActionTypes.USER_ACTION_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case resourceActionTypes.USER_FOLDER_RESOURCES_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };
    case resourceActionTypes.USER_FOLDER_RESOURCES_SUCCESS:
      return {
        ...state,
        [`${action.folderName.toLowerCase()}s`]: action.clear
          ? action.resources
          : [..._.get(state, `${action.folderName.toLowerCase()}s`, []), ...action.resources],
        [`${action.folderName}Skip`]: action.skip,
        [`${action.folderName}Limit`]: action.limit,
        [`hasMore${action.folderName}`]: action.resources.length !== 0,
        loading: false,
      };
    case resourceActionTypes.USER_FOLDER_RESOURCES_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    case resourceActionTypes.IMAGE_TAGS_REQUEST:
      return {
        ...state,
        error: action.error,
      };
    case resourceActionTypes.IMAGE_TAGS_SUCCESS:
      return {
        ...state,
        imageTags: action.imageTags,
      };
    case resourceActionTypes.IMAGE_TAGS_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case resourceActionTypes.CREATE_FOLDER_REQUEST:
      return {
        ...state,
        error: null,
        folderState: 'creating',
      };
    case resourceActionTypes.CREATE_FOLDER_SUCCESS:
      return {
        ...state,
        userFolders: action.folders ? action.folders : [],
        folderState: 'created',
      };
    case resourceActionTypes.CREATE_FOLDER_FAILURE:
      return {
        ...state,
        error: action.error,
        folderState: 'createFailed',
      };
    case resourceActionTypes.ADD_TO_FOLDER_REQUEST:
      return {
        ...state,
        error: null,
        folderState: 'adding',
      };
    case resourceActionTypes.ADD_TO_FOLDER_SUCCESS:
      return {
        ...state,
        [`${action.folderId.toLowerCase()}s`]: [
          ..._.get(state, `${action.folderId.toLowerCase()}s`, []),
          action.resource,
        ],
        folderState: 'added',
      };
    case resourceActionTypes.ADD_TO_FOLDER_FAILURE:
      return {
        ...state,
        error: action.error,
        folderState: 'addFailed',
      };
    case resourceActionTypes.REMOVE_FROM_FOLDER_REQUEST:
      return {
        ...state,
        error: null,
        folderState: 'removing',
      };
    case resourceActionTypes.REMOVE_FROM_FOLDER_SUCCESS:
      return {
        ...state,
        [`${action.folderId.toLowerCase()}s`]: action.resources,
        folderState: 'removed',
      };
    case resourceActionTypes.REMOVE_FROM_FOLDER_FAILURE:
      return {
        ...state,
        error: action.error,
        folderState: 'removeFailed',
      };
    case resourceActionTypes.DELETE_FOLDER_REQUEST:
      return {
        ...state,
        error: null,
        folderState: 'deleting',
      };
    case resourceActionTypes.DELETE_FOLDER_SUCCESS:
      return {
        ...state,
        userFolders: action.folders ? action.folders : [],
        folderState: 'deleted',
      };
    case resourceActionTypes.DELETE_FOLDER_FAILURE:
      return {
        ...state,
        error: action.error,
        folderState: 'deleteFailed',
      };
    case resourceActionTypes.STATISTIC_REQUEST:
      return {
        ...state,
        error: null,
      };
    case resourceActionTypes.STATISTIC_SUCCESS:
      return {
        ...state,
        statistic: action.resources,
      };
    case resourceActionTypes.STATISTIC_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    case resourceActionTypes.STATISTIC_LATEST_REQUEST:
      return {
        ...state,
        error: null,
      };
    case resourceActionTypes.STATISTIC_LATEST_SUCCESS:
      return {
        ...state,
        latestStatistic: action.resources,
      };
    case resourceActionTypes.STATISTIC_LATEST_FAILURE:
      return {
        ...state,
        error: action.error,
      };
    default:
      return state;
  }
}
